/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Meta_Oauth_OkInputs */

const cs_settings_meta_oauth_ok = /** @type {(inputs: Settings_Meta_Oauth_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osobní Meta propojena.`)
};

const en_settings_meta_oauth_ok = /** @type {(inputs: Settings_Meta_Oauth_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal Meta connected.`)
};

/**
* | output |
* | --- |
* | "Personal Meta connected." |
*
* @param {Settings_Meta_Oauth_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_meta_oauth_ok = /** @type {((inputs?: Settings_Meta_Oauth_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Meta_Oauth_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_meta_oauth_ok(inputs)
	return cs_settings_meta_oauth_ok(inputs)
});